import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses')({
  beforeLoad: () => getTitleContextSlice('Ticket Statuses'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
